import moment from 'moment';

class OrderCreateController {

    constructor($window, $state, basket, messageService, propertyService, ordersApiService) {
        this.$window = $window;
        this.$state = $state;
        this.basket = basket;
        this.messageService = messageService;
        this.propertyService = propertyService;
        this.ordersApiService = ordersApiService;
    }

    $onInit () {
        this.loading = ['basket', 'order'];

        return this.getBasket();
    }

    getBasket () {
        return this.basket.get()
            .then(response => {
                if (!this.basket.isEmpty()) {
                    this.stopLoading('basket');
                    return this.generateOrder();
                }

                return this.$state.go('app.admin.basket-create');
            });
    }

    generateOrder () {
        // return this.ordersApiService.generateOrder(this.basket.contents.identity_code)
        //     .then(response => {
        //         this.order = response;
        //     })
        //     .catch(error => {
        //         this.displayError(error);
        //     })
        //     .then(() => {
        //         this.stopLoading('order');
        //     });
    }

    displayError (error) {
        this.messageService.failure(error);
        this.messageService.push();
        this.messageService.autoClear();
    }

    stopLoading (param) {
        const index = this.loading.indexOf(param);
        if (index > -1) {
            this.loading.splice(index, 1);
        }
    }

    isLoading (param) {
        if (param) {
            return this.loading.indexOf(param) > -1;
        }

        return this.loading.length > 0;
    }

    displayPayment () {
        return !!(this.basket
            && this.basket.contents
            && this.basket.contents.guest_details
            && this.basket.contents.guest_details.find(guest => {
                return guest.id && guest.item_details.length > 0;
            }));
    }

    basketValidUntil () {
        if (this.basket.contents.expires_at) {
            return moment(`${this.basket.contents.expires_at}+00:00`).format('LLLL');
        }
    }

    displayFinalActions () {

    }

    onSave () {

    }

    onSuccess () {

    }

    onError () {

    }
}

OrderCreateController.$inject = ['$window', '$state', 'basket', 'messageService', 'propertyService', 'ordersApiService'];

export default OrderCreateController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/orderCreation/controllers/order.create.controller.js